import { ReactElement } from 'react';

import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';

export const DeliveryErrorTooltip = ({
  errorCode,
  side = 'bottom',
  children,
}: {
  errorCode?: string;
  side?: 'top' | 'bottom';
  children: ReactElement;
}): ReactElement => {
  const { t, i18n } = useTranslation();
  const key = `error_codes.${errorCode}`;

  if (!errorCode || !i18n.exists(key)) {
    return children;
  }

  return (
    <InfoTooltip content={t(key)} size="large" side={side} showArrow>
      {children}
    </InfoTooltip>
  );
};
